import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useMatch } from 'react-router-dom';

import Posale from 'components/Posale';

import { changePasswordUrl } from 'constants/routes';

import { loginStatus } from 'pages/posale/login/Login';

const AuthWrapper = ({ persistor }) => {
  const match = useMatch({ path: changePasswordUrl, end: true });
  const { session_token, status } = useSelector((state) => state.redux.user);

  if (session_token === null) {
    return <Navigate to='/posale/login' replace={true} />;
  }
  if (!match && status === loginStatus.pending) {
    return <Navigate to={changePasswordUrl} replace={true} />;
  }

  return <Posale persistor={persistor} />;
};

export default AuthWrapper;
